import { render, staticRenderFns } from "./metadata-panel.vue?vue&type=template&id=23d5befa&scoped=true"
import script from "./metadata-panel.ts?vue&type=script&lang=ts&external"
export * from "./metadata-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./metadata-panel.scss?vue&type=style&index=0&id=23d5befa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d5befa",
  null
  
)

export default component.exports